const PATH = '/chart';

export default {
    async getChartBySymbol(symbol) {

        return axios.get(`${PATH}/${symbol}`);
    }
}
